// Zod Enums (equivalent to above, for Zod validation)
import {z} from "zod";
import mongoose from "mongoose";
import {objectIdSchema, zBaseDocument} from '@schemas/shared.schemas';
import {
    APPLICATION_DEFAULT_STATUS,
    APPLICATION_DEFAULT_TYPE,
    ApplicationStatus,
    ApplicationType
} from "@typesDef/application.types";

export const zApplicationStatus = z.enum([
    ApplicationStatus.pending,
    ApplicationStatus.accepted,
    ApplicationStatus.rejected,
    ApplicationStatus.withdrawn,
    ApplicationStatus.cancelled
]);
export const zApplicationType = z.enum([ApplicationType.announcer_application, ApplicationType.provider_request]);
// Zod schema for applicants
const zApplicant = z.object({
    announcerId: objectIdSchema
});

const zActivity = z.object({
    statusFrom: zApplicationStatus,
    statusTo: zApplicationStatus,
    message: z.string().max(200).default(""),
    userId: objectIdSchema,
    createdAt: z.string().optional()
});

// Zod schema for Application
export const zApplicationSchema = zBaseDocument.extend({
    eventId: objectIdSchema,
    providerId: objectIdSchema,
    applicants: z.array(zApplicant),
    status: zApplicationStatus.default(APPLICATION_DEFAULT_STATUS),
    type: zApplicationType.default(APPLICATION_DEFAULT_TYPE),
    activities: z.array(zActivity).default([])
});

// Inferred TypeScript type from the Zod schema
export type ZApplication = z.infer<typeof zApplicationSchema>;

// Zod schema for QueryResult
const zQueryResultApplications = z.object({
    count: z.number().default(0),
    results: z.array(zApplicationSchema).default([]),
})
export type ZQueryResultApplications = z.infer<typeof zQueryResultApplications>;

export type ZApplicant = z.infer<typeof zApplicant>;


export const validateApplication = (data: object, throwError: boolean=false) => {
    if(throwError) return zApplicationSchema.parse(data);
    return zApplicationSchema.safeParse(data);
}
/*
// test
const testObj = {
    eventId: "55",
    jo: 3,
    providerId: "456",
    applicants: [{announcer4Id: "789"}]
}

const { success, data, error } = validateApplication(testObj);
console.log("success", success);
console.log("data", data);
console.log("error", error);
if(!success) {
    logger.error("import validate error " + JSON.stringify(error.format()));
    throw error;
}
*/

